import { HttpInterceptorFn } from '@angular/common/http';
import { CACHING_ENABLED } from '../setup/config';
import { inject } from '@angular/core';
import { LoggerService } from '../shared/logger.service';
import { CacheService } from '../services/cache-service';

export const cachingInterceptor: HttpInterceptorFn = (req, next) => {
  const logger = inject(LoggerService);
  const cacheService = inject(CacheService);

  if (req.context.get(CACHING_ENABLED)) {
    logger.debug(`caching being used...`);
    return next(req);
  } else {
    // logger.debug(`no caching here`);
    return next(req);
  }
};
